export default __webpack_public_path__ + "static/media/chevron-arrow-down-2.7d78d573.svg";